import {
  SpaceProps,
  BackgroundColorProps,
  FlexboxProps,
  LayoutProps,
  BackgroundProps,
  PositionProps,
  LineHeightProps,
} from "styled-system";
import {
  BP_CONTAINER_PAD_X,
  BP_CONTAINER_PAD_Y,
  BP_MAX_WIDTH,
} from "../constants/data";
import { HTMLAttributes } from "react";
import { Box } from "@bpba/ui-components";
import styled from "styled-components";

export type ModuleContainerGenericProps = {
  children: React.ReactNode;
  css?: any;
} & SpaceProps &
  LayoutProps &
  FlexboxProps &
  BackgroundProps &
  PositionProps &
  BackgroundColorProps &
  LineHeightProps &
  HTMLAttributes<HTMLDivElement>;

export const ModuleContainerGeneric = (props: ModuleContainerGenericProps) => {
  const {
    maxWidth,
    children,
    display,
    flexWrap,
    justifyContent,
    alignItems,
    flexDirection,
    ...otherProps
  } = props;

  return (
    <StyledBox
      paddingX={BP_CONTAINER_PAD_X}
      paddingY={BP_CONTAINER_PAD_Y}
      display="flex"
      flexWrap="wrap"
      justifyContent="center"
      flexDirection="row"
      width="100%"
      {...otherProps}
    >
      <Box
        width="100%"
        maxWidth={maxWidth ? maxWidth : [null, null, null, BP_MAX_WIDTH]}
        display={display}
        flexWrap={flexWrap}
        alignItems={alignItems}
        justifyContent={justifyContent}
        flexDirection={flexDirection ? flexDirection : "column"}
      >
        {children}
      </Box>
    </StyledBox>
  );
};

const StyledBox = styled(Box)<{ css?: any }>((props) => {
  return props.css;
});

ModuleContainerGeneric.displayName = "ModuleContainerGeneric";
